/**
 * هوکِ پیش‌نمایشِ PDF — یک خط برای هر صفحه:
 *
 *   const pdf = usePdfPreview();
 *   // تکی
 *   pdf.open({ url, title, fallbackName, onEdit, storageKey: "statement" })
 *   // لیستی (قبلی/بعدی + جست‌وجو)
 *   pdf.open({ items, index, resolve: (it) => ({ url, title, fallbackName, onEdit }), labelOf, storageKey })
 *   {pdf.node}
 *
 * تا هر PDFِ برنامه (فیش حقوق، فرم پرسنل، صورتحساب…) اول دیده شود، بعد دانلود/چاپ.
 */
import React, { useCallback, useState } from "react";
import PdfPreviewModal from "../components/PdfPreviewModal";

export default function usePdfPreview() {
  const [st, setSt] = useState({ open: false, props: {} });
  const open = useCallback((props) => setSt({ open: true, props: props || {} }), []);
  const close = useCallback(() => setSt((s) => ({ ...s, open: false })), []);
  const node = <PdfPreviewModal open={st.open} onClose={close} {...st.props} />;
  return { open, close, node, isOpen: st.open };
}
